import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation } from "swiper/modules";
// import { ChevronLeft } from "lucide-react";
import Partner from "../../assets/Partner1.jpg"
import Partner2 from "../../assets/Partner2.jpg"
const OurPartners = () => {
    const partnerImages = [Partner, Partner2, Partner, Partner2,Partner, Partner2, Partner, Partner2 ,Partner, Partner2, Partner, Partner2]
    return (
        <div className='bg-[#3D50F812] lg:h-[260px] sm:h-[220px]  h-[190px] flex items-center relative sm:mt-0 mt-20'>
            
            {/* <div className="flex justify-between mx-auto items-center w-full absolute top-1/2 -translate-y-1/2 z-[9999999] px-10">
                <button className="custom-prev5 flex items-center justify-center size-[60px]">
                    <ChevronLeft size={40} className="text-primary" />
                </button>
                <div>
                    <div className="custom-pagination2"></div>
                </div>
                <button className="custom-next5 flex items-center justify-center size-[60px]">
                    <ChevronLeft className="rotate-180 text-primary" size={40} />
                </button>
            </div> */}

            <div className="container">
                <div>
                    <h1 className="sm:text-base text-sm font-semibold text-secondary text-center">Our Partners</h1>
                    <br></br>
                </div>
                <Swiper
                    loop={true}
                    navigation={{
                        nextEl: ".custom-next5",
                        prevEl: ".custom-prev5",
                    }}
                    grabCursor={true}
                    autoplay={{
                        delay: 500,
                        disableOnInteraction: false,
                    }} 
                    modules={[Autoplay,  Navigation]}
                    speed={3000}
                    breakpoints={{
                        0: {
                            slidesPerView: 4,
                            spaceBetween: 8,
                        },
                        450: {
                            slidesPerView: 5,
                            spaceBetween: 8,
                        },
                        570: {
                            slidesPerView: 6,
                            spaceBetween: 8,
                        },
                        900: {
                            slidesPerView: 6,
                            spaceBetween: 40,
                        }
                    }}
                    className="mySwiper !overflow-hidden w-full !z-[999999999] "
                >
                    {partnerImages.map((partner, index) => (
                        <SwiperSlide className="!h-auto" key={index}>
                            <div className="flex items-center h-full">
                                <img src={partner} alt={`Partner ${index + 13}`} />
                            </div>
                        </SwiperSlide>
                    ))}
                </Swiper>

            </div>
        </div>
    )
}

export default OurPartners